import type { Client } from "../client";
import type { NamedReferenceItem } from "../resources/namedReferenceItem";

export class ExternalSecurityGroupRepository {
    private client: Client;
    constructor(client: Client) {
        this.client = client;
    }
    search(url: string, partialName: string): Promise<NamedReferenceItem[]> {
        return this.client.get(url, { partialName });
    }
}
